import { render, staticRenderFns } from "./szr.vue?vue&type=template&id=f24a7532&scoped=true"
import script from "./szr.vue?vue&type=script&lang=js"
export * from "./szr.vue?vue&type=script&lang=js"
import style0 from "./szr.vue?vue&type=style&index=0&id=f24a7532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a7532",
  null
  
)

export default component.exports